__turbopack_context__.v({
  "tabHit": "E1XUyG_tabHit",
  "tabLabel": "E1XUyG_tabLabel",
  "thumb": "E1XUyG_thumb" + " " + __turbopack_context__.i(917291)["lbToggleBlur"],
  "track": "E1XUyG_track" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeFrosted"] + " " + __turbopack_context__.i(917291)["lbToggleBlur"],
});
